export const LockReleaseValidation = (formData) => {
    const errors = {};
  
    // Validate each field
  //  if (!formData.ContractPrefix.trim()) {
  //    errors.ContractPrefix = 'This field is required';
  //  } 
  
    return errors;
  };
  
 